export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

export const PNG_HEADER = "data:image/png;base64,";

export const MIME_TYPE = {
    JSON: "application/json",
    PDF: "application/pdf",
};
